import { computed, ref, useRouter } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import useRouteExclusion from '@shared/composables/useRouteExclusion';
import { useFitmentSearch } from '@unified-commerce/gpc-vue-storefront-search';

import { FITMENT_SHOP_PARTS_PATH } from '~/constants';

import getSearchParams from './getSearchParams';

const showFittingParts = ref(true);

const useFitment = () => {
  const router = useRouter();
  const { globalConfig } = useBrandConfig();
  const config = globalConfig.fitment;
  const { isExcluded } = useRouteExclusion();
  const { search: searchFitment, result, loading } = useFitmentSearch('products-fitment');

  const isFitmentRoute = computed(() => !isExcluded(config));

  const includeNonFitmentParts = computed(() => config.includeNonFitmentParts);

  const includeUniversalParts = computed(() => config.includeUniversal);

  const navigateToParts = (route?: string) => {
    if (config.autoToggleFitmentOnNavigateToParts) {
      showFittingParts.value = true;
    }
    router.push(route ?? FITMENT_SHOP_PARTS_PATH);
  };

  const search = async (searchResultsSkus: string[], userSelectedVehicleId: number) => {
    if (userSelectedVehicleId && searchResultsSkus.length > 0) {
      await searchFitment(getSearchParams(searchResultsSkus, userSelectedVehicleId));
    }
  };

  return {
    search,
    result,
    loading,
    isFitmentRoute,
    includeNonFitmentParts,
    includeUniversalParts,
    showFittingParts,
    navigateToParts,
  };
};

export default useFitment;
